var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 产业加加是为产业人提供在线招商及项目投资选址所需的随身工具，助力找到产业（industry）和投资（investment）方向 "),_c('div',[_vm._v("主要包括首页榜单模块,雷达模块,我的模块")])])}]

export { render, staticRenderFns }